class GrantType
{
    static AUTHORIZATION_CODE = 'authorization_code' ;
    static CLIENT_CREDENTIALS = 'client_credentials' ;
    static REFRESH_TOKEN      = 'refresh_token'
}

export default GrantType